@import "../../styles/variables.scss";
@import "../../styles/mixin.scss";

.nav-bar {
  margin-top: 0;
}
